module.exports = __webpack_public_path__ + "static/media/cvetomer-5.50fbe222.png";